export const RADIUS_TOKENS = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '32px',
} as const;

export type RadiusTokens = typeof RADIUS_TOKENS;
export type RadiusTokenKey = keyof RadiusTokens;
export type RadiusTokenValue = RadiusTokens[RadiusTokenKey];
